import React from "react";
import { Routes, Route } from "react-router-dom";
import BackToTop from "../components/common/BackToTop";
import useScrollToTop from "../hooks/useScrollToTop";
// # components
import Home from "../pages/Home";
import PasswordProtected from "../pages/PasswordProtected";
import Experiences from "../pages/Experiences";
import Experience from "../pages/Experience";
import AboutUs from "../pages/AboutUs";

function AppRouter() {
  const routes = [
    {
      path: "/password-protected",
      element: <PasswordProtected />,
      key: "password-protected",
    },
    {
      path: "/",
      element: <Home />,
      key: "home",
    },
    {
      path: "/experiences",
      element: <Experiences />,
      key: "experiences",
    },
    {
      path: "/experiences/:type",
      element: <Experience />,
      key: "experience",
    },
    {
      path: "/about-us",
      element: <AboutUs />,
      key: "about-us",
    },
  ];

  // This is a custom hook that will scroll to the top of the page when the route changes.
  useScrollToTop();

  return (
    <main>
      <Routes>
        {routes.map(({ path, element, key }) => (
          <Route key={key} path={path} element={element} />
        ))}
      </Routes>

      <BackToTop />
    </main>
  );
}

export default AppRouter;
